<p-toast key="portal" [baseZIndex]="5000"></p-toast>

<div class="container_box_login">

  <div style="margin: 0 auto;" class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top text-center d-none d-lg-block" *ngIf="habilitar_banner">
    <a href="https://postulacioningresoespecial.uv.cl/" style="margin-left: 10%;">
      <img src="assets/img/banner_imagen.png"  width="50%" height="80px" style="max-width: 600px;">
    </a>
  </div>

  <div style="margin: 0 auto; " class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top text-center d-lg-none" *ngIf="habilitar_banner">
    <a href="https://postulacioningresoespecial.uv.cl/">
      <img src="assets/img/banner_imagen.png" width="100%" height="60px" style="max-width: 500px;">
    </a>

  </div>
  <table class="table_box">




    <!-- ************* INFORMACION PANTALLAS CHICAS ************* -->


    <tr *ngIf="avisos.length > 0" class="d-lg-none">
      <td valign="top" style="padding-bottom: 10px;">
        <div class="card card-container paddingLogin {{avisos.length > 0 ? 'margin-top' : ''}}">
          <div class="text-center margin-bottom titulo_box" style="color:white;">
            <i class="fa fa-bullhorn"></i> Informativo
          </div>
          <ng-container *ngFor="let notice of avisos;let indice=index;">
            <a class="linkNotice"><span style="color:white" class="small"> <i class="fas fa-angle-right"></i>
                {{notice.titulo}}</span></a>
            <div class=" body_advice small">
              <span [innerHTML]="notice.cuerpo" style="color:white"></span>
            </div>
          </ng-container>
        </div>
      </td>
    </tr>

    <tr>


      <!-- ************* INFORMACION PANTALLAS GRANDES ************* -->


      <td valign="top" class="d-none d-lg-block" *ngIf="avisos.length > 0">
        <div class="card card-container paddingLogin {{avisos.length > 0 ? 'margin-top' : ''}}">
          <div class="text-center margin-bottom titulo_box" style="color:white;">
            <i class="fa fa-bullhorn"></i> Informativo
          </div>
          <ng-container *ngFor="let notice of avisos;let indice=index;">
            <a class="linkNotice"><span style="color:white" class="small"> <i class="fas fa-angle-right"></i>
                {{notice.titulo}}</span></a>
            <div class=" body_advice small">
              <span [innerHTML]="notice.cuerpo" style="color:white"></span>
            </div>
          </ng-container>
        </div>
      </td>


      <!-- ************* LOGIN ************* -->


      <td valign="top">

        <div class="card card-container main-container">

          <!-- <div class="margin-bottom margin-top text-center">
            <img src="https://repositorio.uv.cl/imagenes/logouv/logoUV.png" width="170">
          </div> -->


          <!-- ************* HEADER ************* -->


          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top ">

            <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 text-center">
              <h5 style="color:white;">Call center: 600 818 8825 </h5>
            </div>

            <table style="width: 100%">
              <tr>
                <td class="text-center">
                  <span style="color:white;">¿Eres extranjero?</span>
                  <p-checkbox (onChange)="change_extranjero();" [(ngModel)]="extranjero" binary="true"
                    [style]="{'margin-left':'10px'}">
                  </p-checkbox>
                </td>

              </tr>
            </table>

          </div>


          <!-- ************* RUT Y DV ************* -->


          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
            <div class="row paddingLogin">
              <div
                class="{{!extranjero ? 'col-lg-10 col-md-10 col-sm-10 col-xs-10' : 'col-lg-12 col-md-12 col-sm-12 col-xs-12'}} no-padding margin-top">
                <span class="text-white">{{!extranjero ? 'Rut' : 'Pasaporte'}}</span>

                <input type="text" (keypress)="onlyNumbers($event);" pInputText [(ngModel)]="cuenta.usuario"
                  maxlength="8" class="form-control input_user" (change)="reset_error(0);validate_rut()"
                  *ngIf="!extranjero" />

                <input type="text" pInputText [(ngModel)]="cuenta.usuario" class="form-control input_user"
                  (change)="reset_error(0);" *ngIf="extranjero" />

                <span class="small text-white">{{exampleHome}}</span>

              </div>

              <div class="col-lg-2 col-md-2 col-sm-2 col-xs-2 no-padding margin-top" *ngIf="!extranjero">
                <span class="text-white">DV</span>
                <input type="text" pInputText [(ngModel)]="cuenta.dv" maxlength="1" class="form-control input_user"
                  [disabled]="true"
                  style="text-align: center; background-color:transparent !important; color: white !important;" />
              </div>

              <span class="small text-rojo">{{errorHome[0]}}</span>

            </div>
          </div>


          <!-- ************* CONTRASEÑA ************* -->


          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top paddingLogin">
            <span class="text-white">Contraseña (Sistema de acceso DEMRE)</span>

            <p-password [(ngModel)]="cuenta.clave" [style]="{'width':'100%','margin-top': '5px'}"
              [inputStyle]="{'width':'100%'}" [toggleMask]="true" [feedback]="false">
            </p-password>

            <span class="small text-rojo margin-top">{{errorHome[1]}}</span>

            <h6 class="text-white margin-top">* Si la postulación es por medio de ingreso especial, ingresar
              con la contraseña enviada a tu correo.</h6>

          </div>


          <!-- ************* CAPTCHA ************* -->


          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-top margin-bottom text-center"
            style="color:white;">

            <ng-container *ngIf="(recaptcha || {} ).render">
              <p-captcha style="display: inline-block;transform: scale(1.00);
            transform-origin: 0 0;" siteKey="{{captcha_keysite}}" #captcha (onResponse)="validate_captcha($event)"
                (onExpire)="expire_captcha($event)">
              </p-captcha>
            </ng-container>


            <br />

            <span class="small text-rojo">{{errorHome[2]}}</span>

          </div>


          <!-- ************* LOGIN ************* -->


          <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12 no-padding text-center margin-top"
            style="margin-bottom: 20px;">
            <button pButton type="button" label="Ingresar" icon="pi pi-sign-in" class="p-button-rounded"
              (click)="getLogin()"></button>
          </div>


          <!-- ************* RECUPERAR CONTRASEÑA ************* -->


          <div class="text-center small" style="color:white;">
            ¿Olvidaste tu contraseña?, haz click aquí:<br>
            <a href="https://inscripcion.demre.cl/recuperaclave" target="_blank" style="color:#F0AD4E;">Recuperar
              contraseña DEMRE</a>
          </div>

          <div class="text-center paddingLogin">
            <img alt="Universidad de Valparaíso" style="display:initial !important;height: 70px"
              onerror="this.onerror=null;this.src='./assets/img/noIcon.png';"
              src="https://repositorio.uv.cl/imagenes/logouv/logo-ac6-blanco.png" />
          </div>

        </div>

      </td>


      <!-- ************* ENLACES PANTALLAS GRANDES ************* -->


      <td valign="top" *ngIf="enlaces.length > 0" class="d-none d-lg-block">
        <div class="card card-container paddingLogin " style="margin: 0 auto;">
          <div class="text-center margin-bottom titulo_box" style="color:white;">
            <i class="fas fa-link"></i> Enlaces
          </div>
          <ng-container *ngFor="let link of enlaces">
            <a href="{{link.url}}" target="_blank" style="text-decoration: none;">
              <div class="link_inferior_box" pTooltip="{{link.info}}">
                <img alt="{{link.name}}" src="./assets/img/{{link.icon}}" height="24" />
                <span style="padding-left:10px;color:white;font-size:15px;">{{link.name}}</span>
              </div>
            </a>
          </ng-container>
        </div>
      </td>

    </tr>

    <!-- ************* ENLACES PANTALLAS CHICAS ************* -->

    <tr *ngIf="enlaces.length > 0" class="d-lg-none">
      <td valign="top" style="padding-top: 10px;">
        <div class="card card-container paddingLogin">
          <div class="text-center margin-bottom titulo_box" style="color:white;">
            <i class="fas fa-link"></i> Enlaces
          </div>
          <ng-container *ngFor="let link of enlaces">
            <a href="{{link.url}}" target="_blank" style="text-decoration: none;">
              <div class="link_inferior_box" pTooltip="{{link.info}}">
                <img alt="{{link.name}}" src="./assets/img/{{link.icon}}" height="24" />
                <span style="padding-left:10px;color:white;font-size:15px;">{{link.name}}</span>
              </div>
            </a>
          </ng-container>
        </div>
      </td>
    </tr>

  </table>
</div>